var _excluded = ["svgElement", "htmlAttributes", "children", "isChildrenOnRight"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from "../../styles/theme";
import Button from "./Button";
var CONFIG = {
  iconMargin: '0.6rem'
};
var styles = StyleSheet.create({
  iconWrapper: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  iconLeft: {
    marginRight: CONFIG.iconMargin
  },
  iconRight: {
    marginLeft: CONFIG.iconMargin
  }
});

/**
 * A Button that handles interaction when having svg icon as children
 */
var SvgButton = /*#__PURE__*/function (_React$Component) {
  function SvgButton() {
    var _this;
    _classCallCheck(this, SvgButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SvgButton, [].concat(args));
    _defineProperty(_this, "state", {
      hovered: false,
      focused: false
    });
    _defineProperty(_this, "handleMouseEnter", function (e) {
      _this.setState({
        hovered: true
      });
      _this.callEventIfExists('onMouseEnter', e);
    });
    _defineProperty(_this, "handleMouseLeave", function (e) {
      _this.setState({
        hovered: false
      });
      _this.callEventIfExists('onMouseLeave', e);
    });
    _defineProperty(_this, "handleFocus", function (e) {
      _this.setState({
        focused: true
      });
      _this.callEventIfExists('onFocus');
    });
    _defineProperty(_this, "handleBlur", function (e) {
      _this.setState({
        focused: false
      });
      _this.callEventIfExists('onBlur');
    });
    return _this;
  }
  _inherits(SvgButton, _React$Component);
  return _createClass(SvgButton, [{
    key: "callEventIfExists",
    value: function callEventIfExists(name, event) {
      var targetFunction = this.props.htmlAttributes[name];
      if (targetFunction) {
        targetFunction(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        svgElement = _this$props.svgElement,
        htmlAttributes = _this$props.htmlAttributes,
        children = _this$props.children,
        isChildrenOnRight = _this$props.isChildrenOnRight,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var _this$state = this.state,
        hovered = _this$state.hovered,
        focused = _this$state.focused;
      return /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
        isChildrenOnRight: isChildrenOnRight,
        htmlAttributes: _objectSpread(_objectSpread({}, htmlAttributes), {}, {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        })
      }), isChildrenOnRight && children, svgElement && /*#__PURE__*/React.createElement("span", css(styles.iconWrapper, 'cui-iconWrapper', (rest.label || children) && !isChildrenOnRight && styles.iconLeft, (rest.label || children) && isChildrenOnRight && styles.iconRight), svgElement && /*#__PURE__*/React.cloneElement(svgElement, {
        hovered: hovered || focused,
        disableMouseEvent: true
      })), !isChildrenOnRight && children);
    }
  }]);
}(React.Component);
_defineProperty(SvgButton, "propTypes", {
  svgElement: PropTypes.node,
  htmlAttributes: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  children: PropTypes.node,
  isChildrenOnRight: PropTypes.bool
});
_defineProperty(SvgButton, "defaultProps", {
  htmlAttributes: {}
});
export default SvgButton;